import React from "react";
import PropTypes from "prop-types";

export default class Technicals extends React.Component{

    static propTypes = {
        serviceDetail: PropTypes.object,
    }

    render() {
        return (
            <div className="detail-info">
                <span>Technicals</span>
            </div>
        )
    }
}
